

/** @type {import('.')} */
module.exports = Error;




//////////////////
// WEBPACK FOOTER
// ../node_modules/es-errors/index.js
// module id = ../node_modules/es-errors/index.js
// module chunks = 0